import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, typography, palette, breakpoints }) => ({
  root: {
    marginBottom: spacing(3)
  },
  divider: {
    margin: spacing(3, 0)
  },
  authorSection: {
    marginBottom: spacing(4),
    paddingTop: spacing(3)
  },
  authorSectionTitle: {
    fontWeight: typography.fontWeightBold,
    marginBottom: spacing(2),
    color: palette.text.primary
  },
  breadcrumbs: {
    marginBottom: spacing(2),
    [breakpoints.down('sm')]: {
      marginBottom: spacing(3)
    }
  },
  description: {
    marginBottom: spacing(4)
  },
  topics: {
    marginBottom: spacing(4)
  },
  pagination: {
    marginTop: spacing(4)
  },
  filterBar: {
    marginBottom: spacing(4),
    [breakpoints.down('sm')]: {
      marginBottom: spacing(3)
    }
  }
}))
